import type { CSSProperties, FC } from 'react';
import type { EditorCardId, EditorOverviewStats } from '../types';
import {
  EditorConnectionsIcon,
  EditorDocToolsIcon,
  EditorFilesIcon,
  EditorStatsIcon,
  EditorWorkCenterIcon,
} from './EditorIcons';

interface EditorCabinetGridProps {
  stats: EditorOverviewStats;
  onSelectCard: (id: EditorCardId) => void;
  activeCard?: EditorCardId | null;
}

interface CardMeta {
  id: EditorCardId;
  num: string;
  title: string;
  subtitle: string;
  badge: string;
  accent: string;
  icon: FC<{ className?: string }>;
}

export const EditorCabinetGrid: FC<EditorCabinetGridProps> = ({
  stats,
  onSelectCard,
  activeCard,
}) => {
  const cards: CardMeta[] = [
    {
      id: 'EDITOR_WORK_CENTER',
      num: '01',
      title: 'Мои заявки',
      subtitle: 'Статья, соавторство, редакционный проект, материалы и согласование.',
      badge: `${stats.total_objects} объектов`,
      accent: '#e2ad3a',
      icon: EditorWorkCenterIcon,
    },
    {
      id: 'EDITOR_DOC_TOOLS',
      num: '02',
      title: 'Документы и инструменты',
      subtitle: 'Редакционные шаблоны и исследовательские инструменты.',
      badge: 'Шаблоны + AI',
      accent: '#49ddb7',
      icon: EditorDocToolsIcon,
    },
    {
      id: 'ACADEMIC_CONNECTIONS',
      num: '03',
      title: 'Академические связи',
      subtitle: 'Авторы, рецензенты, команда и другие категории платформы.',
      badge: `${stats.unread_messages_count} сообщений`,
      accent: '#41d2ff',
      icon: EditorConnectionsIcon,
    },
    {
      id: 'EDITOR_STATS',
      num: '04',
      title: 'Статистика',
      subtitle: 'Принятые, возвращённые, ожидающие и завершённые материалы.',
      badge: `${stats.active_objects} активных`,
      accent: '#9e80ff',
      icon: EditorStatsIcon,
    },
    {
      id: 'B5_FILES',
      num: '05',
      title: 'Файлы и документы',
      subtitle: 'Архив файлов, версий, материалов и итоговых документов.',
      badge: 'Архив версий',
      accent: '#66b7e8',
      icon: EditorFilesIcon,
    },
  ];

  return (
    <section style={{ marginTop: 32 }} aria-label="Разделы кабинета редактора">
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Разделы</h2>
        <p style={{ margin: '4px 0 0', color: '#8faebb', fontSize: 12 }}>
          5 канонических карточек редакции
        </p>
      </div>

      <div className="owner-hub-grid">
        {cards.map((card) => {
          const Icon = card.icon;
          const isActive = activeCard === card.id;

          return (
            <button
              key={card.id}
              type="button"
              onClick={() => onSelectCard(card.id)}
              className={`owner-hub-card${isActive ? ' is-opening' : ''}`}
              style={{ '--action': card.accent } as CSSProperties}
            >
              <span className="owner-hub-index">{card.num}</span>
              <span className="owner-hub-icon" aria-hidden="true">
                <Icon className="w-5 h-5" />
              </span>
              <span className="owner-hub-copy">
                <strong>{card.title}</strong>
                <span>
                  {card.subtitle} · {card.badge}
                </span>
              </span>
              <span className="owner-hub-arrow" aria-hidden="true">
                ›
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};
